
import React from 'react';
import UserManagement from '@/components/superadmin/UserManagement';

const SuperadminUsers = () => {
  return (
    <div className="space-y-6 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
      <div>
        <h2 className="text-xl font-bold tracking-tight">User Management</h2>
      </div>
      <UserManagement />
    </div>
  );
};

export default SuperadminUsers;
